module.exports = __webpack_public_path__ + "staticcomp/img/content_5.adf438b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/content_5.jpg
// module id = uuBW
// module chunks = 39